module.exports = __webpack_public_path__ + "img/caplena.ae0349c7.png";